import { ONE_HUNDRED, ZERO } from '@/constants';

export const validStatsPercentage = (value: number, total: number) => {
  const percentage = Math.round((value * ONE_HUNDRED) / total);
  if (Number.isNaN(percentage)) return ZERO;
  return percentage;
};
